<div style="background-color: #f0f0f0; padding: 20px;">
	<h1 class="text-center">Veicoli in evidenza</h1>
	<ngb-carousel *ngIf="veicoli && veicoli.length">
		<ng-template ngbSlide *ngFor="let veicolo of veicoli">
			<div class="picsum-img-wrapper">
				<a class="link" routerLink="veicolo-usato/{{veicolo.vclPratica}}">
					<img class="img-fluid card-img link" [src]="veicolo.imageToShow">
				</a>
			</div>
			<div class="carousel-caption" style="background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)); color: white !important;">
				<a class="link" routerLink="veicolo-usato/{{veicolo.vclPratica}}">

					<b>({{veicolo.vclPratica}}) <span
							*ngIf="veicolo.vclTipologia != '' || veicolo.vclcntVclTipo != ''">{{veicolo.vclTipologia}}
							{{veicolo.vclcntVclTipo}}
							-</span> Anno: {{veicolo.vclDataImmatr | date:'yyyy'}}</b>
					<br>
					<br>
					{{veicolo.vclMarca}} {{veicolo.vclMod}} {{veicolo.vclAliment}}
					<br>
					Data immatr.
					{{veicolo.vclDataImmatr | date:'dd/MM/yyyy'}}
					<br>
					Km {{veicolo.vclKmPercorsi}}
					<br>
					
				</a>
			</div>
		</ng-template>
	</ngb-carousel>
</div>